import { VerticalNavigation } from '@zg-rentals/rental-manager-header-navigation';

import { StyledVerticalNavigationContainer } from './styles';

import type { HeaderNavigationProps } from '@zg-rentals/rental-manager-header-navigation';

type Props = HeaderNavigationProps & {
  /**
   * altLogo true - zrm logo
   * altLogo false - zillow logo
   */
  altLogo?: boolean;
  hideHeaderNavigation?: boolean;
  bodyContent?: React.ReactNode;
  /*
   * pathname
   *
   * the current path so the link can be highlighted
   */
  pathname: string;
};

const HorizontalLayoutVerticalNavigationContainer = ({
  altLogo = true,
  hideHeaderNavigation = false,
  pathname,
  ...rest
}: Props) => {
  return (
    <StyledVerticalNavigationContainer
      data-testid="VerticalNavigationContainer"
      hideHeaderNavigation={hideHeaderNavigation}
    >
      <VerticalNavigation altLogo={altLogo} pathname={pathname} displayMainMaintenanceTracker={false} {...rest} />
    </StyledVerticalNavigationContainer>
  );
};

export { HorizontalLayoutVerticalNavigationContainer };
